import React, { Component } from 'react';
import {
    Container, Row, Col, Form, FormGroup, Input, Label, Button,
    Card, CardImg, Progress, Spinner
} from 'reactstrap';
import Empresa from '../../utilitarios/infoEmpresa';
import Horarios from './horarios';
import { database } from '../../config';
import './adminEmpresa.css';
import { Icon } from 'react-icons-kit';
import { trash } from 'react-icons-kit/fa/trash'

import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";

const empresa = new Empresa()

export default class AdminEmpresa extends Component {
    constructor(props) {
        super(props)

        this.state = {
            infoEmpresa: empresa,
            imgEmpresa: [],
            porcentaje: 0,
            guardando: false,
            notificacion: null
        }
        this.onChange = this.onChange.bind(this)
        this.guardarInfoEmpresa = this.guardarInfoEmpresa.bind(this)
        this.onChangeImg = this.onChangeImg.bind(this)
        this.actualizarImgProgress = this.actualizarImgProgress.bind(this)
        this.eliminarImagen = this.eliminarImagen.bind(this)
        this.guardarHorario = this.guardarHorario.bind(this)

        this.addNotification = this.addNotification.bind(this)
        this.notificationDOMRef = React.createRef()
    }

    addNotification(notification) {
        this.notificationDOMRef.current.addNotification({
            title: notification.title,
            message: notification.message,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 2000 },
            dismissable: { click: true }
        });
    }

    onChange(e) {
        e.preventDefault()
        this.setState({
            infoEmpresa: {
                ...this.state.infoEmpresa,
                [e.target.id]: e.target.value
            }
        })
    }

    onChangeImg(e) {
        empresa.guardarImgEmpresa(e.target.files[0], this.actualizarImgProgress)
    }

    actualizarImgProgress(porcentaje) {
        this.setState({
            porcentaje: porcentaje == 100 ? 0 : porcentaje
        })
    }

    eliminarImagen(e) {
        if (window.confirm(`¿Desea eliminar ésta imagen?`)) {
            empresa.eliminarImgEmpresa(e.target.id)
        }
    }

    guardarInfoEmpresa(e) {
        e && e.preventDefault()
        const _this = this
        this.setState({
            guardando: true
        })

        empresa.guardarInfoEmpresa(this.state.infoEmpresa).then(() => {
            _this.setState({
                guardando: false
            })
            _this.addNotification({
                title: '',
                message: 'Datos guardados con éxito!'
            })
        }).catch(_this.error)

    }

    getInfoEmpresa() {
        const _this = this

        empresa.getInfoEmpresa().then(data => {
            _this.setState({
                infoEmpresa: data
            })
        })
    }

    getImgEmpresa() {
        let _this = this
        database.collection('imgEmpresa')
            .onSnapshot(querySnapshot => {
                _this.setState({
                    imgEmpresa: querySnapshot.docs
                })
            })
    }

    guardarHorario(dia) {
        let { horarios } = this.state.infoEmpresa
        let update = false

        horarios.forEach((d, index) => {
            if (d.Dia === dia.Dia) {
                horarios[index] = dia
                update = true
            }
        })

        !update && horarios.push(dia)

        this.setState({
            infoEmpresa:{
                ...this.state.infoEmpresa,
                horarios
            }
        })

        this.guardarInfoEmpresa()
    }

    error(err){

    }

    componentDidMount() {
        this.getInfoEmpresa()
        this.getImgEmpresa()
    }

    render() {
        return (
            <Container className="InfoEmpresaAdmin">
                <h2>Información de Empresa</h2>
                <ReactNotification ref={this.notificationDOMRef} />
                <Row className="adminEmpresa">
                    <Col xs={12} md={6}>
                        <Form className="formEdicion" onSubmit={this.guardarInfoEmpresa}>
                            <Row form>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label for="Telefono">Teléfono</Label>
                                        <Input onChange={this.onChange} value={this.state.infoEmpresa.Telefono} type="text" id="Telefono" placeholder="Teléfono fijo" />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label for="Celular">Celular</Label>
                                        <Input onChange={this.onChange} value={this.state.infoEmpresa.Celular} type="text" id="Celular" placeholder="Celular" />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label for="Whatsapp">Whatsapp</Label>
                                        <Input onChange={this.onChange} value={this.state.infoEmpresa.Whatsapp} type="text" id="Whatsapp" placeholder="Whatsapp" />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <FormGroup>
                                <Label for="Direccion">Dirección</Label>
                                <Input onChange={this.onChange} value={this.state.infoEmpresa.Direccion} type="text" id="Direccion" placeholder="Dirección" />
                            </FormGroup>
                            <FormGroup>
                                <Label for="Correo">Email</Label>
                                <Input onChange={this.onChange} value={this.state.infoEmpresa.Correo} type="text" id="Correo" placeholder="Correo electrónico" />
                            </FormGroup>
                            <FormGroup>
                                <Label for="Descripcion">Descripción</Label>
                                <Input onChange={this.onChange} value={this.state.infoEmpresa.Descripcion} type="textarea" rows="5" id="Descripcion" placeholder="Descripción de la empresa" />
                            </FormGroup>
                            {
                                this.state.guardando ?
                                    <Button disabled={true} color="success"><Spinner color="light" size="sm" /></Button>
                                    :
                                    <Button disabled={false} color="success">Guardar</Button>
                            }
                            <FormGroup className="EmpresaHorario">
                                <Horarios horarios={this.state.infoEmpresa.horarios} guardarHorario={this.guardarHorario} />
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col xs={12} md={6} className="formEdicion">
                        <FormGroup>
                            <Input onChange={this.onChangeImg} className="btn btn-outline-dark btn-sm" type="file" name="file" id="Img" />
                            {
                                this.state.porcentaje > 0 && <Progress id="ImgProgress" animated color="warning" value={this.state.porcentaje} />
                            }
                        </FormGroup>
                        <Row>
                            {
                                this.state.imgEmpresa.map((item) => {
                                    return (
                                        <Col key={item.id} xs={6}>
                                            <Card className="imgEmpresaAdmin">
                                                <CardImg src={item.data().src} alt={item.data().altText} />
                                                <Button onClick={this.eliminarImagen} id={item.id} outline color="danger" size="sm" className="btnEliminarImg">
                                                    <Icon className="IconTrash" size={12} icon={trash} /> {' '}
                                                    Eliminar
                                                </Button>
                                            </Card>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </Col>
                </Row>
            </Container>
        )
    }

}
